// constants
export const Constants = {
	empty: '',
	space: ' ',
	all: 'all',
	all_kr: '전체',
	new: 'new',
	yes: 'Y',
	no: 'N',
	apiSuccess: 'OK',
	fileServer: '',
	fsws: {
		licenseKey: '',
		maxPool: 0,
		serviceUri: ''
	}
};
